import { Component, OnInit,ViewChild, AfterViewInit, OnDestroy } from '@angular/core';
import  {SERVICES } from '../../config/webservices';
import  {MESSAGES } from '../../config/messages';
import { ServicesProvider } from '../../providers/services';
import ScrollBooster from 'scrollbooster'
import { SwiperComponent, SwiperDirective, SwiperConfigInterface,
  SwiperScrollbarInterface, SwiperPaginationInterface } from 'ngx-swiper-wrapper';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

@Component({
  selector: 'landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss']
})
export class LandingComponent implements OnInit, AfterViewInit, OnDestroy {

  mobileMenuOpen = false;

  toggleMobileMenu() {
    this.mobileMenuOpen = !this.mobileMenuOpen;
  }

  oSlideManual:any={
    index:1,
    translateX:0
  };

  private pagination: SwiperPaginationInterface = {
    el: '.swiper-pagination',
    clickable: true,
    hideOnClick: false
  };
  public config: SwiperConfigInterface = {
    a11y: true,
    direction: 'horizontal',
    slidesPerView: 1,
    keyboard: true,
    scrollbar: false,
    navigation: true,
    pagination: true,
    speed:1000,
    simulateTouch:true,
    mousewheel:false,
    autoplay:true
  };
  /*private scrollbar: SwiperScrollbarInterface = {
    el: '.swiper-scrollbar',
    hide: false,
    draggable: true
  };*/



  @ViewChild('swiperWrapper') public swiperWrapper: any;
  @ViewChild(SwiperDirective) directiveRef?: SwiperDirective;
  constructor(

      public ServicesProvider:ServicesProvider/*,
      private route: ActivatedRoute*/

    ) { }

  





  ngOnInit() {
    this.fn_stickyHeader();
    this.fn_carruselManual(this.oSlideManual.index);
  }

  ngAfterViewInit() {
    this.initScrollAnimations();
  }

  ngOnDestroy() {
    ScrollTrigger.getAll().forEach(trigger => trigger.kill());
  }

  initScrollAnimations() {
    const sections = document.querySelectorAll('.segunda_seccion, .seccion_tecnologias, .page-footer, .hero-section');
    
    sections.forEach((section, index) => {
      gsap.fromTo(section, 
        { 
          opacity: 0, 
          y: 50,
          rotationX: 5
        },
        {
          opacity: 1,
          y: 0,
          rotationX: 0,
          duration: 0.8,
          ease: 'power3.out',
          scrollTrigger: {
            trigger: section,
            start: 'top 90%',
            toggleActions: 'play none none reverse'
          }
        }
      );
    });

    const heroElements = document.querySelectorAll('.hero-content, .hero-left, .hero-right, .hero-title, .hero-description, .hero-badge, .cta-buttons, .tech-strip-container');
    heroElements.forEach((el, i) => {
      gsap.fromTo(el,
        { 
          opacity: 0, 
          y: 40, 
          rotationX: 10,
          transformPerspective: 1000
        },
        {
          opacity: 1,
          y: 0,
          rotationX: 0,
          duration: 0.8,
          delay: i * 0.08,
          ease: 'power3.out',
          scrollTrigger: {
            trigger: '.hero-section',
            start: 'top 80%',
            toggleActions: 'play none none reverse'
          }
        }
      );
    });

    const productCards = document.querySelectorAll('.producto-card');
    productCards.forEach((card, i) => {
      const row = Math.floor(i / 5);
      const col = i % 5;
      gsap.fromTo(card,
        { 
          opacity: 0, 
          y: 40, 
          rotationY: 10,
          rotationX: 5,
          scale: 0.8,
          transformPerspective: 1000
        },
        {
          opacity: 1,
          y: 0,
          rotationY: 0,
          rotationX: 0,
          scale: 1,
          duration: 0.5,
          delay: row * 0.08 + col * 0.03,
          ease: 'back.out(1.2)',
          scrollTrigger: {
            trigger: card,
            start: 'top 90%',
            toggleActions: 'play none none reverse'
          }
        }
      );
    });

    const subtitles = document.querySelectorAll('.section-subtitle');
    subtitles.forEach((subtitle, i) => {
      gsap.fromTo(subtitle,
        { 
          opacity: 0, 
          x: -40,
          rotationY: -5,
          transformPerspective: 1000
        },
        {
          opacity: 1,
          x: 0,
          rotationY: 0,
          duration: 0.6,
          delay: i * 0.03,
          ease: 'power3.out',
          scrollTrigger: {
            trigger: subtitle,
            start: 'top 90%',
            toggleActions: 'play none none reverse'
          }
        }
      );
    });

    const solutionContents = document.querySelectorAll('.solution-content');
    solutionContents.forEach((el, i) => {
      gsap.fromTo(el,
        { 
          opacity: 0, 
          y: 30, 
          rotationX: 5,
          transformPerspective: 1000
        },
        {
          opacity: 1,
          y: 0,
          rotationX: 0,
          duration: 0.6,
          ease: 'power3.out',
          scrollTrigger: {
            trigger: el,
            start: 'top 90%',
            toggleActions: 'play none none reverse'
          }
        }
      );
    });

    const solutionDescriptions = document.querySelectorAll('.solution-description');
    solutionDescriptions.forEach((el, i) => {
      gsap.fromTo(el,
        { 
          opacity: 0, 
          y: 20,
          scale: 0.98,
          transformPerspective: 800
        },
        {
          opacity: 1,
          y: 0,
          scale: 1,
          duration: 0.5,
          ease: 'power2.out',
          scrollTrigger: {
            trigger: el,
            start: 'top 90%',
            toggleActions: 'play none none reverse'
          }
        }
      );
    });

    const featureItems = document.querySelectorAll('.feature-item');
    featureItems.forEach((item, i) => {
      gsap.fromTo(item,
        { 
          opacity: 0, 
          x: -30, 
          rotationY: -8,
          transformPerspective: 1000
        },
        {
          opacity: 1,
          x: 0,
          rotationY: 0,
          duration: 0.5,
          delay: i * 0.05,
          ease: 'power3.out',
          scrollTrigger: {
            trigger: item,
            start: 'top 90%',
            toggleActions: 'play none none reverse'
          }
        }
      );
    });

    const featureTitles = document.querySelectorAll('.feature-title, .feature-sub');
    featureTitles.forEach((el, i) => {
      gsap.fromTo(el,
        { 
          opacity: 0, 
          y: 10
        },
        {
          opacity: 1,
          y: 0,
          duration: 0.3,
          ease: 'power2.out',
          scrollTrigger: {
            trigger: el,
            start: 'top 92%',
            toggleActions: 'play none none reverse'
          }
        }
      );
    });

    const productosGrid = document.querySelectorAll('.productos-grid, .seccion_productos');
    productosGrid.forEach((el) => {
      gsap.fromTo(el,
        { opacity: 0, y: 30, scale: 0.98 },
        {
          opacity: 1,
          y: 0,
          scale: 1,
          duration: 0.6,
          ease: 'power2.out',
          scrollTrigger: {
            trigger: el,
            start: 'top 85%',
            toggleActions: 'play none none reverse'
          }
        }
      );
    });

    const techStripItems = document.querySelectorAll('.tech-item, .tech-strip-item');
    techStripItems.forEach((item, i) => {
      gsap.fromTo(item,
        { 
          opacity: 0, 
          scale: 0.7,
          rotationY: 90,
          transformPerspective: 1000
        },
        {
          opacity: 1,
          scale: 1,
          rotationY: 0,
          duration: 0.5,
          delay: i * 0.03,
          ease: 'back.out(1.5)',
          scrollTrigger: {
            trigger: '.seccion_tecnologias',
            start: 'top 85%',
            toggleActions: 'play none none reverse'
          }
        }
      );
    });

    

    const glowElements = document.querySelectorAll('.glow-cyan, .glow-blue');
    glowElements.forEach((el, i) => {
      gsap.to(el, {
        y: i % 2 === 0 ? -100 : 100,
        x: i % 2 === 0 ? 50 : -50,
        ease: 'none',
        scrollTrigger: {
          trigger: '.datalab-container',
          start: 'top top',
          end: 'bottom bottom',
          scrub: 2
        }
      });
    });
  }

  fn_goTToSection(section:any){
    
  /*    var elmnt: any = document.getElementById(section);
      elmnt.scrollIntoView({ block: 'start', behavior: 'smooth' });
*/
      const yourElement = document.getElementById(section);
      const yCoordinate = yourElement.getBoundingClientRect().top + window.pageYOffset;
      const yOffset = -100; 
      
      window.scrollTo({
          top: yCoordinate + yOffset,
          behavior: 'smooth'
      });

    
  }
   
  fn_stickyHeader(){
    var header = document.getElementById("header");
    if (!header) return;
    
    var sticky = header.offsetTop;
    window.onscroll = function() {myFunction()};
    function myFunction() {
      if (window.pageYOffset > sticky) {
        header.classList.add("sticky");
        header.classList.remove("d-none");

          /*      opciones_menu.classList.remove("d-none");

        (document.querySelector(".opciones_menu.d-flex.justify-content-center.align-items-center") as HTMLElement).style.display = "none !important";
        console.log(document.querySelector(".opciones_menu.d-flex.justify-content-center.align-items-center"));
*/
        //document.getElementById("logo").setAttribute("src","./assets/img/logo.png")
      } else {

        
        header.classList.remove("sticky");
        header.classList.add("d-none");
        //opciones_menu.classList.add("d-none");


        //document.getElementById("logo").setAttribute("src","./assets/img/logo2.png")

      }
    }
  }


  fn_carruselManual(index:any){
    console.log("entra");
    setTimeout(()=>{

          //3 slides
          if(this.oSlideManual.index==5){
            this.oSlideManual.index=1;
            this.oSlideManual.translateX=0;

            (document.querySelector("#slide4")  as HTMLElement).style.transform = "translate(100%,0%)";
            (document.querySelector("#slide3")  as HTMLElement).style.transform = "translate(100%,0%)";            
            (document.querySelector("#slide2")  as HTMLElement).style.transform = "translate(100%,0%)";
            (document.querySelector("#slide1")  as HTMLElement).style.transform = "translate(100%,0%)";
            (document.querySelector("#slide0")  as HTMLElement).style.transform = "translate(0%,0%)";

            (document.querySelector("#slide4 .carrusel_texto")  as HTMLElement).style.transform = "translate(0%,0%)";
            (document.querySelector("#slide4 .carrusel_texto")  as HTMLElement).style.display = "none";


            (document.querySelector("#slide3 .carrusel_texto")  as HTMLElement).style.transform = "translate(0%,0%)";
            (document.querySelector("#slide3 .carrusel_texto")  as HTMLElement).style.display = "none";


            (document.querySelector("#slide2 .carrusel_texto")  as HTMLElement).style.transform = "translate(0%,0%)";
            (document.querySelector("#slide2 .carrusel_texto")  as HTMLElement).style.display = "none";

            (document.querySelector("#slide1 .carrusel_texto")  as HTMLElement).style.transform = "translate(0%,-0%)";
            (document.querySelector("#slide1 .carrusel_texto")  as HTMLElement).style.display = "none";

            (document.querySelector("#slide0 .carrusel_texto")  as HTMLElement).style.transform = "translate(0%,0%)";

            this.fn_carruselManual( this.oSlideManual.index);


          }
          else{
            //poner logo blanco para los img backgruond que apliquen
            /*if(this.oSlideManual.index==3){
              setTimeout(()=>{
                document.getElementById("logo").setAttribute("src","./assets/img/logo2.png")

              },1000)
            }
            else{
              setTimeout(()=>{
                document.getElementById("logo").setAttribute("src","./assets/img/logo.png")

              },1000)
            }*/
            (document.querySelector("#slide0 .carrusel_texto")  as HTMLElement).style.display = "block";
            (document.querySelector("#slide1 .carrusel_texto")  as HTMLElement).style.display = "block";
            (document.querySelector("#slide2 .carrusel_texto")  as HTMLElement).style.display = "block";
            (document.querySelector("#slide3 .carrusel_texto")  as HTMLElement).style.display = "block";
            (document.querySelector("#slide4 .carrusel_texto")  as HTMLElement).style.display = "block";

            (document.querySelector("#slide"+this.oSlideManual.index)  as HTMLElement).style.transform = "translate(0%,0%)";
            let index=this.oSlideManual.index-1;
            (document.querySelector("#slide"+index+" .carrusel_texto")  as HTMLElement).style.transform = "translate(-100%,0%)";
  
              this.oSlideManual.translateX=this.oSlideManual.translateX-100;
            
            this.oSlideManual.index=this.oSlideManual.index+1;
  
              //(document.querySelector("#slide"+index)  as HTMLElement).style.transform = "translate("+this.oSlideManual.translateX+"%,0%)";
            this.fn_carruselManual( this.oSlideManual.index);
  
          }

    },6000);
  }

 
  public onIndexChange(index: number): void {
    console.log('Swiper index: ', index);
    
    
    

  }
  public onSwiperEvent(event: string): void {
    console.log('Swiper event: ', event);
    console.log('Swiper event: ', event);
    if(event=="transitionStart"){
    }
    else{
    }
  }

 
}